import React, { useEffect, useState } from "react";
import {
  Form,
  Title,
  Input,
  Button,
  ModalOverlay,
  ModalContent,
  CloseButton,
  RecaptchaWrapper,
  ErrorShow,
  InputWrapper,
} from "./style";
import ReCAPTCHA from "react-google-recaptcha";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logoImg from "../assets/logo/Logo.png";

const RegisterModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    recaptchaValue: "",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (!isOpen) {
      setFormData({
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
        recaptchaValue: "",
      });
      setErrors({});
    }
  }, [isOpen]);

  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.password) newErrors.password = "Password is required";
    else if (formData.password.length < 6)
      newErrors.password = "Password must be at least 6 characters.";
    if (formData.password !== formData.confirmPassword)
      newErrors.confirmPassword = "Passwords do not match";
    if (!formData.recaptchaValue)
      newErrors.recaptcha = "Please complete the reCAPTCHA";
    return newErrors;
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_URL}/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          password: formData.password,
          password_confirmation: formData.confirmPassword,
          recaptchaValue: formData.recaptchaValue,
        }),
      });

      const responseData = await response.json();

      if (!response.ok) {
        if (responseData.errors && responseData.errors.email) {
          setErrors({ email: responseData.errors.email[0] });
          toast.error(responseData.errors.email[0]);
        } else {
          if (responseData.message === "Invalid email verification link") {
            setErrors({ email: "Invalid email verification link" });
            toast.error("Invalid email verification link");
          } else if (responseData.message === "Email is already verified") {
            setErrors({ email: "Email is already verified" });
            toast.error("Email is already verified");
          } else {
            throw new Error(
              responseData.errors
                ? JSON.stringify(responseData.errors)
                : "Failed to register"
            );
          }
        }
      } else {
        localStorage.setItem("auth", JSON.stringify(responseData));
        toast.success(
          "Welcome! We've sent a verification email to your email address. Please confirm to activate."
        );
        setTimeout(onClose, 3000);
      }
    } catch (error) {
      console.error("Error during registration:", error);
      setErrors({ email: error.message });
      toast.error(error.message);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleRecaptchaChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      recaptchaValue: value,
    }));
  };

  if (!isOpen) return null;

  return (
    <>
      <ModalOverlay />
      <ModalContent>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <Form onSubmit={handleRegister}>
          <Title>
          <img width={200} src={logoImg} alt="logo" />
          </Title>
          <InputWrapper>
            <Input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleInputChange}
            />
            {errors.name && <ErrorShow>{errors.name}</ErrorShow>}
          </InputWrapper>
          <InputWrapper>
            <Input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleInputChange}
            />
            {errors.email && <ErrorShow>{errors.email}</ErrorShow>}
          </InputWrapper>
          <InputWrapper>
            <Input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleInputChange}
            />
            {errors.password && <ErrorShow>{errors.password}</ErrorShow>}
          </InputWrapper>
          <InputWrapper>
            <Input
              type="password"
              name="confirmPassword"
              placeholder="Confirm password"
              value={formData.confirmPassword}
              onChange={handleInputChange}
            />
            {errors.confirmPassword && (
              <ErrorShow>{errors.confirmPassword}</ErrorShow>
            )}
          </InputWrapper>
          <InputWrapper>
            <RecaptchaWrapper>
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={handleRecaptchaChange}
              />
            </RecaptchaWrapper>
            {errors.recaptcha && <ErrorShow>{errors.recaptcha}</ErrorShow>}
          </InputWrapper>
          <Button type="submit">Register</Button>
        </Form>
      </ModalContent>
    </>
  );
};

export default RegisterModal;
